import a from "react";
import e from "@mui/material/Pagination";
function i(n) {
  return /* @__PURE__ */ a.createElement(
    e,
    {
      count: n.pageCount,
      shape: "rounded",
      siblingCount: 1,
      boundaryCount: 1,
      page: n.page,
      onChange: n.onChange
    }
  );
}
export {
  i as P
};
